import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PasswordResetService {
  private base = `${environment.baseUrl}/auth/password-reset`;

  constructor(private http: HttpClient) {}

  initiate(email: string): Observable<any> {
    return this.http.post<any>(`${this.base}/initiate`, { email });
  }

  verify(email: string, otp: string): Observable<any> {
    return this.http.post<any>(`${this.base}/verify`, { email, otp });
  }

  complete(reset_token: string, new_password: string): Observable<any> {
    return this.http.post<any>(`${this.base}/complete`, { reset_token, new_password });
  }

  resend(email: string): Observable<any> {
    return this.http.post<any>(`${this.base}/resend`, { email });
  }
}
